import { ChangeEvent, Fragment } from "react";
import { RpServiceAttributePropertyTypes } from "@enums/rp-service-attribute-property-types";
import { FormattedRpServiceConfigurationAttribute } from "@idw-types/data/rp-service-configuration";
import { RpServiceAttributeProperty } from "@idw-types/data/reference-data/generic";
import { InputFormGroup } from "@containers/common/input-form-group/input-form-group";
import { AttributePropertyRadioInputFormGroup } from "./attribute-property-radio-input-form-group/attribute-property-radio-input-form-group";
import styles from "./attribute-property-row.less";

type AttributePropertyRowProps = {
    attribute: FormattedRpServiceConfigurationAttribute;
    attributeProperty: RpServiceAttributeProperty;
    handleCustomTooltipChange: (event: ChangeEvent<HTMLInputElement>) => void;
    updateAttributeProperty: (attributeProperty: RpServiceAttributePropertyTypes, newValue: string) => void;
    isDisabled: boolean;
};

export const AttributePropertyRow = (props: AttributePropertyRowProps) => {
    const {
        attribute,
        attributeProperty,
        handleCustomTooltipChange,
        updateAttributeProperty,
        isDisabled
    } = props;

    return (
        <Fragment>
            {attributeProperty.type === "Text" && (
                <InputFormGroup
                    controlId={`attribute-${attribute.attributeType?.id}-property-${attributeProperty.name}-input`}
                    className={styles.inputFormGroup}
                    label={attributeProperty.label}
                    ariaLabel={attributeProperty.label}
                    value={attribute[attributeProperty.name] || ''}
                    onChange={handleCustomTooltipChange}
                    isRequired={false}
                    disabled={isDisabled}
                />
            )}
            {attributeProperty.type === "Boolean" && (
                <AttributePropertyRadioInputFormGroup
                    controlId={`attribute-${attribute.attributeType?.id}-property-${attributeProperty.name}-radio-input`}
                    className={styles.radioFormGroup}
                    attributeProperty={attributeProperty}
                    isDisabled={isDisabled}
                    value={attribute[attributeProperty.name]}
                    updateAttributeProperty={updateAttributeProperty}
                />
            )}
        </Fragment>
    );
};